import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { deviceMaxWidth, deviceMinWidth } from '../../constants';
import SrilaPrabhupada from '../../assets/images/srilaPrabhupada.png';
import clsx from 'clsx';

export default function HeadContent() {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.titleInfo}>
        <div className={styles.mainTitle}>
          <span className={styles.accent}>Аудиоархив</span> лекций
          <div>Шрилы Прабхупады</div>
        </div>
        <div className={styles.total}>Всего 3703 аудио</div>
        <div className={styles.left}>
          <span className={styles.leftCount}>
            (осталось перевести 843 лекции)
          </span>
          <span
            onClick={() => alert('Харибол')}
            className={styles.helpTranslate}
          >
            Помочь с переводом
          </span>
        </div>
      </div>
      <div className={styles.ctaInfo}>
        <div className={styles.cta}>
          <div className={styles.subscribe}>Подпишись на рассылку</div>
          <div className={styles.newText}>(новые лекции, новый функционал)</div>
          <div className={styles.button} onClick={() => alert('Подписка')}>
            Подписаться
          </div>
        </div>

        <div className={styles.prabhupadInfo}>
          <img
            src={SrilaPrabhupada}
            className={styles.logo}
            width={96}
            alt="Шрила Прабхупада"
          />
          <div className={styles.infoText}>
            <div className={styles.name}>Его Божественная Милость</div>
            <div className={styles.name}>А.Ч. Бхактиведанта Свами</div>
            <div className={clsx(styles.details, styles.firstLine)}>
              Ачарья-основатель Международного
            </div>
            <div className={styles.details}>
              общества сознания Кришны (ИСККОН)
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    margin: '100px 70px 20px',
    display: 'flex',
    flexDirection: 'row',

    [deviceMinWidth.size501]: {
      [deviceMaxWidth.size1024]: {
        flexDirection: 'column',
      },
    },
    [deviceMaxWidth.size500]: {
      margin: '25px 45px 20px',
    },
  },
  titleInfo: {
    // width: '50%',
    marginBottom: 20,

    [deviceMaxWidth.size500]: {
      [deviceMaxWidth.size1024]: {
        width: '100%', // TODO: FIX
        marginRight: 0,
      },
    },
    [deviceMinWidth.size1201]: {
      [deviceMaxWidth.size1300]: {
        width: '57%',
        maxWidth: 550,
      },
    },
    [deviceMinWidth.size1301]: {
      [deviceMaxWidth.size1440]: {
        width: '46%',
        maxWidth: 900,
      },
    },
    [deviceMinWidth.size1441]: {
      [deviceMaxWidth.size2560]: {
        width: '50%',
        maxWidth: 900,
      },
    },
  },
  ctaInfo: {
    marginLeft: 20,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    [deviceMaxWidth.size500]: {
      display: 'none',
    },
    [deviceMinWidth.size501]: {
      [deviceMaxWidth.size768]: {
        marginLeft: 0,
        flexDirection: 'column',
      },
    },
    [deviceMinWidth.size769]: {
      [deviceMaxWidth.size1024]: {
        marginLeft: 0,
        flexDirection: 'row',
      },
    },
  },
  cta: {
    marginBottom: 20,
    width: 280,
    [deviceMinWidth.size1201]: {
      [deviceMaxWidth.size1300]: {
        width: 220,
      },
    },
    [deviceMinWidth.size1025]: {
      [deviceMaxWidth.size1200]: {
        width: 200,
      },
    },
    [deviceMinWidth.size769]: {
      [deviceMaxWidth.size1024]: {
        width: 280,
      },
    },
    [deviceMinWidth.size601]: {
      [deviceMaxWidth.size768]: {
        // width: 200,
        width: '100%',
      },
    },
    [deviceMaxWidth.size600]: {
      width: '100%',
    },
  },
  subscribe: {
    fontSize: 16,
    fontWeight: 600,
    fontFamily: 'Inter',
    color: '#603004',
    marginTop: 10,
  },
  newText: {
    fontSize: 14,
    fontWeight: 300,
    fontFamily: 'Inter',
    color: '#603004',
    marginTop: 3,
    marginBottom: 20,
  },
  button: {
    width: 135,
    padding: `10px 20px`,
    border: `1px solid #D0690D`,
    fontSize: 14,
    borderRadius: 5,
    color: '#603004',
    cursor: 'pointer',
    textAlign: 'center',
    '&:hover': {
      color: 'white',
      backgroundColor: '#D0690D',
    },
  },
  mainTitle: {
    fontSize: 40,
    lineHeight: 1.1,
    fontWeight: 800,
    color: '#603004',
    marginBottom: 15,

    [deviceMaxWidth.size500]: {
      fontSize: 25,
      lineHeight: `31px`,
      textAlign: 'center',
    },
  },
  accent: {
    color: '#D0690D',
  },
  total: {
    fontSize: 20,
    fontWeight: 600,
    fontFamily: 'Inter',
    color: '#603004',

    [deviceMaxWidth.size500]: {
      textAlign: 'center',
    },
  },
  left: {
    fontSize: 16,
    fontWeight: 400,
    fontFamily: 'Inter',
    color: '#603004',

    [deviceMaxWidth.size500]: {
      display: 'block',
      textAlign: 'center',
    },
  },
  leftCount: {
    [deviceMaxWidth.size500]: {
      marginTop: 10,
      marginBottom: 10,
      display: 'block',
      textAlign: 'center',
    },
  },
  helpTranslate: {
    fontSize: 16,
    fontWeight: 400,
    fontFamily: 'Inter',
    color: '#B65D0D',
    borderBottom: `1px solid #B65D0D`,
    marginLeft: 10,
    cursor: 'pointer',
    '&:hover': {
      color: '#D0690D',
      borderBottom: `1px solid #D0690D`,
    },
  },
  prabhupadInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  infoText: {
    marginLeft: 20,
    color: '#603004',
  },
  name: {
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 600,
    fontFamily: 'Inter',
  },
  details: {
    fontSize: 12,
    lineHeight: 1.5,
    fontStyle: 'italic',
    fontWeight: 300,
    fontFamily: 'Inter',
  },
  firstLine: {
    marginTop: 10,
  },
}));
